module.exports = __webpack_public_path__ + "static/img/12.a17af5e5.png";